import React, { useState } from 'react'
import style from './style.module.scss'
import purple from '@assets/images/wpl/purple.png'
import orange from '@assets/images/wpl/orange.png'
import orangeIcon from '@assets/images/ipl/orange.svg'
import purpleIcon from '@assets/images/ipl/purpleIcon.svg'
import PropTypes from 'prop-types'
import { getImgURL } from '@shared-submodule/utils'
import MyImage from '@shared/components/myImage'

const IPLCapHolder = ({ purpleOrangeCap }) => {
  const orangeCapData = purpleOrangeCap?.data?.listSeriesTopPlayers?.find(d => d?.eFullType === 'batting_most_runs')
  const purpleCapData = purpleOrangeCap?.data?.listSeriesTopPlayers?.find(d => d?.eFullType === 'bowling_top_wicket_takers')
  const [cap, setCap] = useState('purple')
  return (
    <div className='mt-4'>
      <h4 className='m-0'>Cap Holder</h4>
      <div className={style.capBox}>
        <div className={style.themeImg}>
          <span className={style.countText}>Battle of Runs & Wickets!</span>
        </div>
        <div className={style.toggleCap}>
          <div className={style.filterContainer}>
            {['orange', 'purple']?.map((d, i) => {
              return (
                <button key={i} onClick={() => setCap(d)} className={`${style.filterButton} ${d === cap && (cap === 'orange' ? style.activeFilter : cap === 'purple' && style.activePurple)}`}
                >
                  {cap === d && (
                    <MyImage src={d === 'orange' ? orangeIcon : purpleIcon} alt="Orange Icon" width={22} height={22} style={{ marginRight: '0.25rem' }}/>
                  )}  {d.charAt(0).toUpperCase() + d.slice(1)}
                </button>
              )
            })}
          </div>
        </div>
        <div className={`flex text-center ${style.capData}`}>
          {orangeCapData && purpleCapData ? (
            <div className='d-flex flex-row gap-3'>
              <div className='d-flex flex-column'>
                <MyImage src={cap === 'purple' ? purple : orange} height={70} width={120} />
                <h4 className="font-bold text-center">{cap === 'purple' ? `${purpleCapData?.nWickets} Wickets` : `${orangeCapData?.nRuns} Runs`}</h4>
              </div>
              <div className='d-flex flex-column align-items-center'>
                <MyImage className={style.player} src={cap === 'purple' ? getImgURL(purpleCapData?.oPlayer.oImg?.sUrl) : getImgURL(orangeCapData?.oPlayer.oImg?.sUrl)} height={80} width={80} />
                <h5 className="mt-2 mb-1">{cap === 'purple' ? `${purpleCapData?.oPlayer?.sFullName}` : `${orangeCapData?.oPlayer?.sFullName}`}</h5>
                <p className="mx-4 text-center text-small text-secondary">{cap === 'purple' ? `${purpleCapData?.oTeam?.sTitle}` : `${orangeCapData?.oTeam?.sTitle}`}</p>
              </div>
            </div>
          ) : (
            <h3 className='px-4'>To be announced soon...</h3>
          )}
        </div>
        <div className={style.imageTheme}></div>
      </div>
    </div>
  )
}

IPLCapHolder.propTypes = {
  purpleOrangeCap: PropTypes.object
}

export default IPLCapHolder
